var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wrapper"},[_c('canvas',{attrs:{"id":"canvas","hidden":""}}),_c('div',{staticClass:"center"},[_c('h1',[_vm._v("404")]),_c('p',[_vm._v("PAGE NOT FOUND.")])])])
}]

export { render, staticRenderFns }